(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropmagic-style"]) return;
  try {
    

(function patchBodyClass() {
  if (document.body) {
    document.body.classList.add('theme__modal--callback');
  } else {
    setTimeout(patchBodyClass, 10);
  }
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ob-hero')) {
    customElements.define(
      'ob-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.fitWord();
          if (document.fonts) document.fonts.ready.then(() => this.fitWord());
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.ticking = false;
          this.update = () => {
            this.ticking = false;
            const box = this.getBoundingClientRect();
            const p = Math.min(Math.max(-box.top / (box.height * 0.85), 0), 1);
            this.style.setProperty('--obh-p', p.toFixed(4));
          };
          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(this.update);
          };
          // Only listen while the hero is on screen
          this.observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', this.onScroll, { passive: true });
              this.onScroll();
            } else {
              window.removeEventListener('scroll', this.onScroll);
            }
          });
          this.observer.observe(this);
        }

        // Fit the big word's box to its real letters so it scales evenly to full width
        fitWord() {
          const text = this.querySelector('.obh__word text');
          if (!text) return;
          const box = text.getBBox();
          if (!box.width) return;
          const size = parseFloat(getComputedStyle(text).fontSize) || 150;
          const top = 120 - size * 0.74;
          const height = size * 0.76;
          text.ownerSVGElement.setAttribute('viewBox', `${box.x} ${top} ${box.width} ${height}`);
          this.style.setProperty('--obh-word-ratio', (height / box.width).toFixed(4));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          window.removeEventListener('scroll', this.onScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ob-products')) {
    customElements.define(
      'ob-products',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;
          this.onClick = (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (!tab) return;
            event.preventDefault();
            this.select(tab, false);
          };
          this.onKey = (event) => {
            const i = this.tabs.indexOf(document.activeElement);
            if (i < 0) return;
            let next = null;
            if (event.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length];
            if (event.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
            if (event.key === 'Home') next = this.tabs[0];
            if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
            if (!next) return;
            event.preventDefault();
            this.select(next, true);
          };
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKey);
        }

        select(tab, focus) {
          this.tabs.forEach((t) => {
            const on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            const panel = this.querySelector('#' + t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
          if (focus) tab.focus();
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keydown', this.onKey);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-sale-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ob-sale-bar')) {
    customElements.define(
      'ob-sale-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end || '');
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.units = {};
          this.querySelectorAll('[data-obsb-unit]').forEach((u) => {
            this.units[u.dataset.obsbUnit] = { el: u, num: u.querySelector('[data-obsb-num]'), value: null };
          });
          if (!this.end || isNaN(this.end)) return;
          this.onVisible = () => { if (!document.hidden) this.tick(true); };
          document.addEventListener('visibilitychange', this.onVisible);
          this.tick(true);
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          document.removeEventListener('visibilitychange', this.onVisible);
        }

        tick(instant) {
          clearTimeout(this.timer);
          const left = this.end - Date.now();
          if (left <= 0) {
            this.classList.add('is-ended');
            if (!this.querySelector('.obsb__after')) this.hidden = true;
            return;
          }
          const s = Math.floor(left / 1000);
          const parts = {
            d: Math.floor(s / 86400),
            h: Math.floor((s % 86400) / 3600),
            m: Math.floor((s % 3600) / 60),
            s: s % 60
          };
          // Days only show while there are days left
          this.units.d.el.hidden = parts.d === 0;
          for (const key of ['d', 'h', 'm', 's']) {
            const text = key === 'd' ? String(parts.d) : String(parts[key]).padStart(2, '0');
            this.render(this.units[key], text, instant || document.hidden);
          }
          this.classList.toggle('is-final-hour', s < 3600);
          // Wake exactly on the next whole second
          this.timer = setTimeout(() => this.tick(false), 1000 - (left % 1000) + 5);
        }

        render(unit, text, instant) {
          if (unit.value === text) return;
          const old = unit.value || '';
          unit.value = text;
          const num = unit.num;
          // Rebuild when the number of digits changes, otherwise roll only digits that changed
          if (num.children.length !== text.length) {
            num.textContent = '';
            for (const ch of text) {
              const d = document.createElement('span');
              d.className = 'obsb__digit';
              const inner = document.createElement('span');
              inner.textContent = ch;
              d.appendChild(inner);
              num.appendChild(d);
            }
            return;
          }
          [...text].forEach((ch, i) => {
            if (old[i] === ch) return;
            const box = num.children[i];
            const prev = box.firstElementChild;
            const next = document.createElement('span');
            next.textContent = ch;
            box.appendChild(next);
            if (instant || this.reduced || !next.animate) {
              prev && prev.remove();
              return;
            }
            const ease = 'cubic-bezier(0.23, 1, 0.32, 1)';
            next.animate(
              [{ transform: 'translateY(-70%)', opacity: 0 }, { transform: 'none', opacity: 1 }],
              { duration: 320, easing: ease }
            );
            if (prev) {
              const out = prev.animate(
                [{ transform: 'none', opacity: 1 }, { transform: 'translateY(70%)', opacity: 0 }],
                { duration: 220, easing: ease, fill: 'forwards' }
              );
              out.onfinish = () => prev.remove();
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
